// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorGroup_root__ifRh4","error":"ErrorGroup_error__3-3zA"};